// src/admin/pages/AdminSaleProducts.js
import { useState, useRef, useEffect, useContext } from "react";
import AdminProductsBase from "./AdminProductsBase";
import { useNavigate } from "react-router-dom";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import {
  FiTag,
  FiShoppingCart,
  FiPercent,
  FiTruck,
} from "react-icons/fi";

export default function AdminSaleProducts() {
  const navigate = useNavigate();
  const { lang } = useContext(AdminLanguageContext);

  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const ref = useRef();
  const modalRef = useRef();

  const TEXT = {
    EN: {
      make: "Make a Sale",
      remove: "Remove Sale",
      actions: "Actions",
      title: "Select discount type",
      cancel: "Cancel",

      row1: "Amount off products",
      row1Sub: "Discount specific products or collections of products",

      row2: "Buy X get Y",
      row2Sub: "Discount specific products or collections of products",

      row3: "Amount off order",
      row3Sub: "Discount the total order amount",

      row4: "Free shipping",
      row4Sub: "Offer free shipping on an order",
    },
    AR: {
      make: "إضافة تخفيض",
      remove: "إزالة التخفيض",
      actions: "الإجراءات",
      title: "اختر نوع التخفيض",
      cancel: "إلغاء",

      row1: "خصم على المنتجات",
      row1Sub: "تخفيض منتجات أو مجموعات محددة",

      row2: "اشترِ X واحصل على Y",
      row2Sub: "تخفيض منتجات أو مجموعات محددة",

      row3: "خصم على الطلب",
      row3Sub: "تخفيض إجمالي الطلب",

      row4: "شحن مجاني",
      row4Sub: "تقديم شحن مجاني على الطلب",
    },
  }[lang];

  // ✅ close dropdown
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  // ✅ close modal on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setModalOpen(false);
      }
    };
    if (modalOpen) {
      document.addEventListener("mousedown", handleClick);
    }
    return () => document.removeEventListener("mousedown", handleClick);
  }, [modalOpen]);

  return (
    <>
      <AdminProductsBase
        filterType="sale"
        rightAction={
          <div className="relative" ref={ref}>
            
            {/* ACTION BUTTON */}
            <button
              onClick={() => setOpen((v) => !v)}
              className="
                flex items-center gap-1
                h-8 px-3
                bg-[#f6f6f7]
                border border-gray-300
                rounded-lg
                shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
                text-sm font-medium text-gray-900
                hover:bg-gray-100
                transition
              "
            >
              {TEXT.actions}
              <FiChevronDown className="text-gray-500 text-sm" />
            </button>

            {/* DROPDOWN */}
            {open && (
              <div
                className={`
                  absolute top-10 z-50
                  ${lang === "AR" ? "left-0" : "right-0"}
                  w-44
                  bg-white
                  border border-gray-200
                  rounded-xl
                  shadow-[0_10px_30px_rgba(0,0,0,0.15)]
                  p-1
                `}
              >
                {/* MAKE SALE */}
                <button
                  onClick={() => {
                    setOpen(false);
                    navigate("/admin/discounts");
                  }}
                  className="w-full text-left px-3 py-2 rounded-lg text-sm hover:bg-gray-100"
                >
                  {TEXT.make}
                </button>

                {/* REMOVE SALE */}
                <button
                  onClick={() => {
                    setOpen(false);
                    navigate("/admin/discounts");
                  }}
                  className="w-full text-left px-3 py-2 rounded-lg text-sm text-red-600 hover:bg-red-50"
                >
                  {TEXT.remove}
                </button>
              </div>
            )}
          </div>
        }
      />

      {/* ================= MODAL ================= */}
      {modalOpen && (
        <div className="fixed inset-0 z-[999] bg-black/40 flex items-center justify-center">
          
          <div
            ref={modalRef}
            className="
              w-[95%] max-w-lg
              bg-white
              rounded-2xl
              shadow-[0_20px_60px_rgba(0,0,0,0.25)]
              animate-fadeSlide
            "
          >

            {/* HEADER */}
            <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-100 rounded-t-2xl">
              <h2 className="text-lg font-semibold text-gray-900">
                {TEXT.title}
              </h2>

              <button
                onClick={() => setModalOpen(false)}
                className="text-gray-500 hover:text-black text-sm"
              >
                ✕
              </button>
            </div>

            {/* BODY */}
            <div className="divide-y">

              {/* ROW 1 */}
              <button
  onClick={() => {
    setModalOpen(false);
    navigate("/admin/products/make-sale");
  }}
  className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition"
>
  <div className="flex items-start gap-3 text-left">

    {/* ICON */}
    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 text-green-700">
      <FiTag />
    </div>

    {/* TEXT */}
    <div>
      <div className="font-medium text-gray-900">{TEXT.row1}</div>
      <div className="text-sm text-gray-500">{TEXT.row1Sub}</div>
    </div>

  </div>

  <FiChevronRight />
</button>

              {/* ROW 2 */}
              <button className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50">
  <div className="flex items-start gap-3 text-left">

    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-purple-100 text-purple-700">
      <FiShoppingCart />
    </div>

    <div>
      <div className="font-medium">{TEXT.row2}</div>
      <div className="text-sm text-gray-500">{TEXT.row2Sub}</div>
    </div>

  </div>

  <FiChevronRight />
</button>

              {/* ROW 3 */}
              <button className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50">
                <div className="flex items-start gap-3 text-left">

                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-blue-100 text-blue-700">
                    <FiPercent />
                  </div>

                  <div>
                    <div className="font-medium">{TEXT.row3}</div>
                    <div className="text-sm text-gray-500">{TEXT.row3Sub}</div>
                  </div>

                </div>

                <FiChevronRight />
              </button>

              {/* ROW 4 */}
             <button className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50">
                <div className="flex items-start gap-3 text-left">

                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-orange-100 text-orange-700">
                    <FiTruck />
                  </div>

                  <div>
                    <div className="font-medium">{TEXT.row4}</div>
                    <div className="text-sm text-gray-500">{TEXT.row4Sub}</div>
                  </div>

                </div>

                <FiChevronRight />
              </button>

            </div>

            {/* FOOTER */}
            <div className="flex justify-end px-5 py-4 border-t bg-gray-100 rounded-b-2xl">
              <button
                onClick={() => setModalOpen(false)}
                className="
                  px-4 py-2
                  bg-white
                  border border-gray-300
                  rounded-lg
                  text-sm font-medium
                  hover:bg-gray-50
                "
              >
                {TEXT.cancel}
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
}